import { useAtom } from '@reatom/npm-react'
import React from 'react'

import { showShortcutsHintsAtom } from '../../atoms/show-shortcuts-hints'

import { PossibleShortcutHint } from './possible-shortcut-hint'

export const SnackbarShortcutsHint: React.FC = () => {
  const [showShortcutsHints] = useAtom(showShortcutsHintsAtom)

  if (!showShortcutsHints) {
    return undefined
  }

  return <PossibleShortcutHint />
}
